import { connect, ConnectedProps } from "react-redux";
import { ConnectionRetrySuccessBanner } from "./component";
import { getShowConnectionRetrySuccessBanner } from "../../reducer";
import { dismissConnectionRetryBanner } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  showConnectionRetryBanner: getShowConnectionRetrySuccessBanner(state),
});

const mapDispatchToProps = {
  dismissConnectionRetryBanner,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ConnectionRetrySuccessBannerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedConnectionRetrySuccessBanner = connector(
  ConnectionRetrySuccessBanner
);
